<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expenses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Expenses",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expenses",
          active: true,
        },
      ],
      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "supplier",
          sortable: true,
          label: "Supplier",
        },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "paid_field",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "details",
          sortable: true,
          label: "DETAILS",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // edit category
      editdata: {
        id: "",
        amount: "",
        filterdata: {}
      },
      // make inputs required
      amountError: "",
      paidError: "",
      supplierError: "",
      dateError: "",
      categoryError: "",
      modeError: "",
      deletedata: {
        amount: "",
        id: "",
        filterdata: {}
      },
      filterdata: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("expenses", ["ExpensesData", "ExpensesPagination", "IsExpensesServerPaginated", "SaveStatus", "ExpenseCategories", "filterStatus", "ExpensesSummary"]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("stock", [
      "Suppliers",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */
    rows() {
      return this.IsExpensesServerPaginated
          ? this.ExpensesPagination.total
          : (this.ExpensesData ? this.ExpensesData.length : 0);
    },

    /**
     * Current page for pagination
     */
    currentPage: {
      get() {
        return this.IsExpensesServerPaginated ? this.ExpensesPagination.current_page : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsExpensesServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      }
    },

    /**
     * Items per page for pagination
     */
    perPage: {
      get() {
        return this.IsExpensesServerPaginated ? this.ExpensesPagination.per_page : this.clientPerPage;
      },
      set(value) {
        if (this.IsExpensesServerPaginated) {
          this.serverPerPage = value;
          this.handlePageChange(1);
        } else {
          this.clientPerPage = value;
        }
      }
    },
  },
  mounted() {
  },
  updated() {
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpensesReportData",
      AddExpenditure: "expenses/recordExpense",
      EditExpenditure: "expenses/editExpenses",
      DeleteExpense: "expenses/deleteExpense",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchModes: "setting/fetchPaymentOptions",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      if (!this.IsExpensesServerPaginated) {
        this.totalRows = filteredItems.length;
        this.clientCurrentPage = 1;
      }
    },

    resetEditExp() {
      this.editdata.amount = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDeleteExp() {
      this.deletedata.amount = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    showEditModal(data) {
      this.editdata.amount = data.item.amount;
      this.editdata.id = data.item.id;
      this.editdata.filterdata = this.filterdata;
    },
    editExpense(modalId) {
      this.modal_id = modalId;
      this.EditExpenditure(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.amount = data.item.amount;
      this.deletedata.id = data.item.id;
      this.deletedata.filterdata = this.filterdata;
    },
    deleteExpenses(modalId) {
      this.modal_id = modalId;
      this.DeleteExpense(this.deletedata);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    filterReport() {
      const requiresServerPagination = this.filterdata.datefrom !== this.filterdata.dateto;

      let payload = { ...this.filterdata };

      if (requiresServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      } else {
        this.clientCurrentPage = 1;
      }

      this.FetchExpenses(payload);
    },

    handlePageChange(newPage) {
      if (this.IsExpensesServerPaginated) {
        let payload = {
          ...this.filterdata,
          page: newPage,
          per_page: this.serverPerPage
        };
        this.FetchExpenses(payload);
      }
    },
  },
  created() {
    this.filterReport();
    this.FetchExpenseCategories();
    this.FetchModes();
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label>Expense Category</label>
                  <model-list-select
                      :list="ExpenseCategories ? [ { id: '', name: 'All Categories' }, ...ExpenseCategories ] : []"
                      v-model="filterdata.category"
                      option-value="id"
                      option-text="name"
                      class="mb-3"
                      placeholder="Select Category"
                      @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                      type="date"
                      v-model="filterdata.datefrom"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                      type="date"
                      v-model="filterdata.dateto"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end"
                     v-if="!IsExpensesServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <!-- Client-side pagination -->
              <div v-if="!IsExpensesServerPaginated">
                <b-table
                    class="datatables"
                    :items="ExpensesData ? ExpensesData : []"
                    :fields="fields"
                    responsive="sm"
                    :per-page="clientPerPage"
                    :current-page="clientCurrentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    show-empty
                    empty-text="No expenses found for the selected criteria."
                >
                  <template #cell(index)="data">
                    {{ (clientPerPage * (clientCurrentPage - 1)) + data.index + 1 }}
                  </template>
                  <template #cell(amount_field)="data">
                    {{ thousandSeperator(data.item.amount) }}
                  </template>
                  <template #cell(paid_field)="data">
                    {{ thousandSeperator(data.item.paid) }}
                  </template>
                  <template #cell(balance_field)="data">
                    {{ thousandSeperator(data.item.balance) }}
                  </template>
                  <template #cell(details)="data">
                    <table class="table">
                      <tbody>
                      <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                        <td>{{ det.name }}</td>
                        <td>{{ det.amount ? thousandSeperator(det.amount) : 0 }}</td>
                        <td>{{ det.description }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </template>
                  <template #cell(actions)="data">
                    <b-button-group>
                      <b-button
                          v-if="MyUserPerm.edit_expenses == 1"
                          size="sm"
                          variant="primary"
                          v-b-modal.edit-expense-modal
                          @click="showEditModal(data)"
                      ><i class="fa fa-edit"></i> Edit</b-button>
                      <b-button
                          v-if="MyUserPerm.delete_expenses == 1"
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-expense-modal
                          @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i> Delete</b-button>
                    </b-button-group>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </div>

              <!-- Server-side pagination -->
              <div v-else>
                <table class="table table-striped table-bordered table-responsive nowrap w-100 datatables">
                  <thead>
                  <tr>
                    <th v-for="field in fields" :key="field.key">
                      {{ field.label }}
                    </th>
                  </tr>
                  </thead>
                  <tbody v-if="!filterStatus && ExpensesData && ExpensesData.length > 0">
                  <tr v-for="(item, index) in ExpensesData" :key="item.id">
                    <td>{{ ExpensesPagination.from + index }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.supplier }}</td>
                    <td>{{ thousandSeperator(item.amount) }}</td>
                    <td>{{ thousandSeperator(item.paid) }}</td>
                    <td>{{ thousandSeperator(item.balance) }}</td>
                    <td>
                      <table class="table">
                        <tbody>
                        <tr v-for="(det,d) in item.items" :key="d" width="100%">
                          <td>{{ det.name }}</td>
                          <td>{{ det.amount ? thousandSeperator(det.amount) : 0 }}</td>
                          <td>{{ det.description }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <b-button-group>
                        <b-button
                            v-if="MyUserPerm.edit_expenses == 1"
                            size="sm"
                            variant="primary"
                            v-b-modal.edit-expense-modal
                            @click="showEditModal({item: item})"
                        ><i class="fa fa-edit"></i> Edit</b-button>
                        <b-button
                            v-if="MyUserPerm.delete_expenses == 1"
                            size="sm"
                            variant="danger"
                            v-b-modal.delete-expense-modal
                            @click="showDeleteModal({item: item})"
                        ><i class="fa fa-trash"></i> Delete</b-button>
                      </b-button-group>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-if="filterStatus">
                  <tr>
                    <td :colspan="fields.length" class="text-center">
                      <div class="text-warning my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-if="!filterStatus && (!ExpensesData || ExpensesData.length === 0)">
                  <tr>
                    <td :colspan="fields.length" class="text-center">
                      No expenses found for the selected criteria.
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="row" v-if="ExpensesSummary && ExpensesSummary.totalAmount > 0">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>Total Expenses: <span
                      class="text-danger">{{ ExpensesSummary.totalAmount.toLocaleString() }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <Loader v-if="!ExpensesData && !filterStatus"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-expense-modal" hide-footer @hidden="resetEditExp">
              <template #modal-title> Edit Expense of {{ thousandSeperator(editdata.amount) }}</template>
              <div class="input-group">
                <h5>Do you want to Modify this expense? Click Continue to edit.</h5>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('edit-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    v-if="SaveStatus"
                    type="button"
                    class="btn btn-primary"
                    disabled
                >
                  <i class="fa fa-check"></i> Please wait
                  <b-spinner
                      variant="light"
                      small
                      label="Saving"
                  ></b-spinner>
                </button>
                <button
                    v-else
                    type="button"
                    class="btn btn-primary"
                    @click="editExpense('edit-expense-modal')"
                >
                  <i class="fa fa-check"></i> Continue to edit
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-expense-modal"
                hide-footer
                @hidden="resetDeleteExp"
            >
              <template #modal-title> Delete Expenditure of {{ thousandSeperator(deletedata.amount) }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this expense? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    v-if="SaveStatus"
                    type="button"
                    class="btn btn-danger"
                    disabled
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
                <button
                    v-else
                    type="button"
                    class="btn btn-danger"
                    @click="deleteExpenses('delete-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
